import React, { useCallback, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { getImageUrl } from '@culture/common-helpers/cultureUtils';
import { ImageFormatContext } from 'contexts/ImageFormatContext';
import LazyLoadImage from 'components/LazyLoad/Image';

import styles from './styles.module.scss';

const Thumbnail = ({
	file,
	params,
	alt,
	className,
	imgClassName,
	keepRatio,
	align,
	visibleByDefault,
	placeholder
}) => {
	const [isShow, setIsShow] = useState(visibleByDefault);
	const thumbnailCx = cx(
		styles.thumbnail,
		styles[`align_${align}`],
		{
			[styles.keepRatio]: keepRatio,
			[styles.show]: isShow
		},
		className
	);

	const imageFormat = useContext(ImageFormatContext);
	const ratio = (params.height / params.width) * 100;
	const imageSrc = getImageUrl(file, {
		format: imageFormat,
		params: {
			crop: 'fill',
			gravity: 'center',
			...params
		}
	});

	const afterShow = useCallback(() => setIsShow(true), []);

	return (
		<div
			className={thumbnailCx}
			style={{ paddingBottom: keepRatio ? `${ratio}%` : null }}
		>
			<LazyLoadImage
				visibleByDefault={visibleByDefault}
				imageSrc={imageSrc}
				afterShow={afterShow}
				className={styles.imgWrapper}
				placeholder={placeholder}
			>
				<img
					className={cx(styles.img, imgClassName)}
					src={imageSrc}
					alt={alt}
				/>
			</LazyLoadImage>
		</div>
	);
};

Thumbnail.propTypes = {
	visibleByDefault: PropTypes.bool,
	file: PropTypes.object,
	params: PropTypes.object,
	alt: PropTypes.string,
	keepRatio: PropTypes.bool,
	align: PropTypes.oneOf(['center']),
	className: PropTypes.string,
	imgClassName: PropTypes.string,
	placeholder: PropTypes.node
};

Thumbnail.defaultProps = {
	file: {}
};

export default Thumbnail;
